<button mat-icon-button (click)="wsDrawer.toggle()" [class.shake]="shakeState" #messagesOrigin>
  <mat-icon [svgIcon]="'feather:alert-circle'" [matBadge]="getBadgeText()" [matBadgeHidden]="messages().length === 0"></mat-icon>
</button>

<fuse-drawer
  class="w-screen min-w-screen sm:w-140 sm:min-w-140 z-999"
  fixed
  [mode]="'over'"
  [name]="'wsDrawer'"
  [position]="'right'"
  #wsDrawer>

  <div class="flex flex-col w-full overflow-auto bg-card">
    <div class="flex flex-row items-center px-6 h-20 min-h-20 text-on-primary bg-primary">
      <mat-icon class="icon-size-7 text-current" [svgIcon]="'feather:alert-circle'"></mat-icon>
      <div class="ml-3 text-2xl font-semibold tracking-tight">{{ 'genericAlerts' | transloco }}</div>
      <button class="ml-2" mat-icon-button matTooltip="Descartar todas" (click)="dismissAll()">
        <mat-icon class="text-current" [svgIcon]="'mat_outline:delete'"></mat-icon>
      </button>
      <button class="ml-auto" mat-icon-button (click)="wsDrawer.close()">
        <mat-icon class="text-current" [svgIcon]="'mat_outline:close'"></mat-icon>
      </button>
    </div>
    <div class="flex flex-col p-6">
      @if (messages().length > 0) {
        @for (message of messages(); track message; let i = $index) {
          @if (message.payload._genericAlertConfig_; as genericAlert) {
            <div class="py-2">
              <div class="flex justify-between">
                <span class="font-semibold"
                                [ngClass]="{ 'text-[#1d4ed8] dark:text-[#60a5fa]': genericAlert.alertType === 'info',
                                'text-[#22c55e] dark:text-[#4ade80]': genericAlert.alertType === 'success',
                                'text-[#f59e0b] dark:text-[#fbbf24]': genericAlert.alertType === 'warning',
                                'text-[#b91c1c] dark:text-[#f87171]': genericAlert.alertType === 'error' }">
                  {{ getDifference(message) }}
                </span>
                <!-- <span class="text-hint">{{ message.receivedDate | date:'dd MMMM y, HH:mm':'es' }}</span> -->
                <span class="text-hint">{{ message.receivedDate | localizeDate:'long' }}</span>
              </div>
              <fuse-alert [type]="genericAlert.alertType" [appearance]="'border'" [dismissible]="genericAlert.dismissible"
                [showIcon]="genericAlert.showIcon" (dismissedChanged)="dismissAlert(i)">
                <span class="flex items-center justify-between" fuseAlertTitle>
                  {{ genericAlert.alertTitle | localize }}
                  @if (genericAlert.downloadFile) {
                    <button mat-icon-button class="-my-5"
                      (click)="downloadFile(genericAlert.downloadFile)">
                      <mat-icon [svgIcon]="'mat_outline:file_download'"></mat-icon>
                    </button>
                  }
                </span>
                <div class="whitespace-pre-line" fuseAlertMessage>
                  {{ genericAlert.alertText | localize }}
                </div>
              </fuse-alert>
            </div>
          }
        }
      } @else {
        <h3 class="text-center p-4">{{ 'noGenericAlerts' | transloco }}</h3>
      }
    </div>
  </div>
</fuse-drawer>

<ng-template #newMessagePanel>
  <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-140 sm:w-140 sm:rounded-2xl overflow-hidden shadow-lg">
    <!-- Header -->
    <div class="flex shrink-0 items-center justify-between py-4 pr-4 pl-6 bg-primary text-on-primary">
      <div class="text-lg font-medium leading-10">{{ 'newGenericMessage' | transloco }}</div>
      <div class="-ml-1 mr-3">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon class="icon-size-5 text-on-primary" [svgIcon]="'heroicons_solid:x'"></mat-icon>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto px-6 py-2 bg-card">
      @if (newMessage()?.payload._genericAlertConfig_; as newGenericAlert) {
        <fuse-alert [type]="newGenericAlert.alertType" [appearance]="'border'" [dismissible]="newGenericAlert.dismissible"
          [showIcon]="newGenericAlert.showIcon" (dismissedChanged)="dismissNewAlert()">
          <span class="flex items-center justify-between" fuseAlertTitle>
            {{ newGenericAlert.alertTitle | localize }}
            @if (newGenericAlert.downloadFile) {
              <button mat-icon-button class="-my-5"
                (click)="downloadFile(newGenericAlert.downloadFile)">
                <mat-icon [svgIcon]="'mat_outline:file_download'"></mat-icon>
              </button>
            }
          </span>
          <div class="whitespace-pre-line" fuseAlertMessage>
            {{ newGenericAlert.alertText | localize }}
          </div>
        </fuse-alert>
      }
    </div>
  </div>
</ng-template>

